import { Navigate } from 'react-router-dom'
import { SubscriptionActivationDialog } from '@/account/subscription-activation/components/SubscriptionActivationDialog'
import { useSubscriptionActivation } from '@/account/subscription-activation/hooks/useSubscriptionActivation'
import { useHubspotConversations } from '@/context/useHubspotConversations'
import { OcrQuotaPolicy } from '../schemas'
import { Button } from '@/components/button/Button'
import { Header } from '@/components/header/Header'
import { InlineMessage } from '@/components/inline-message/InlineMessage'
import { useOcrQuotaSummary } from '../hooks/useOcrQuotaSummary'
import { OcrUsageDetails } from './OcrUsageDetails'

export function OcrUsagePage() {
  const { isOpen: supportOpen, toggleWidget } = useHubspotConversations()
  const { summary, loading, error, refresh } = useOcrQuotaSummary()
  const activation = useSubscriptionActivation(refresh)
  if (summary && (summary.is_trial !== true || summary.policy === OcrQuotaPolicy.Unlimited)) {
    // Keep payment confirmation visible until Done before leaving the trial-only page.
    return activation.open ? <SubscriptionActivationDialog {...activation} /> : <Navigate to="/dashboard/matters" replace />
  }

  return (
    <div className="grow">
      <Header
        title="Usage"
        endContent={
          <Button type="button" variant="outlined" color="neutral" size="sm" disabled={loading} onClick={() => void refresh()}>
            {loading ? 'Refreshing…' : 'Refresh'}
          </Button>
        }
      />
      <div className="mx-auto max-w-[1026px] space-y-4 px-4 py-6 sm:px-8 md:px-10">
        {error && (
          <InlineMessage variant="neutral">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <span>
                {error}
                {summary ? ' Showing the last available figures.' : ''}
              </span>
              <Button type="button" variant="plain" color="secondary" size="xs" disabled={loading} onClick={() => void refresh()}>
                Retry
              </Button>
            </div>
          </InlineMessage>
        )}
        {!summary && loading ? (
          <p role="status" className="text-sm text-brand-neutral-600">
            Loading OCR usage…
          </p>
        ) : summary ? (
          <OcrUsageDetails
            summary={summary}
            isTrial
            onActivateSubscription={activation.onActivateSubscription}
            onContactSupport={() => {
              if (!supportOpen) toggleWidget()
            }}
          />
        ) : !error ? (
          <p className="text-sm text-brand-neutral-600">OCR usage is not available for this account.</p>
        ) : null}
      </div>
      <SubscriptionActivationDialog {...activation} />
    </div>
  )
}
